import { useAppDispatch } from 'careand-redux/useAppDispatch';
import DefaultModal from 'components/Utils/DefaultModal';
import { uiActions } from 'careand-redux/slices/ui/ui';
import DocumentDetails from 'components/HealthRecords/Documents/DocumentDetails';
import React, { useMemo } from 'react';
import { useAppSelector } from 'careand-redux/store';
import { IsPhysician } from 'careand-redux/selectors';
import BatchApproveDocuments from 'components/HealthRecords/Documents/BatchApproveDocuments';

/**
 * @param {any} props
 */
const DocumentDetailsModal = ({
  document,
  onClose,
  isOpen,
  title = 'Document Details',
  allowPin,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const isPhysician = useAppSelector(IsPhysician);
  const notApproved = document && !document?.approved;

  const showApproveScreen = isPhysician && notApproved && document.id;

  let className = showApproveScreen
    ? 'modal approve-documents-modal large-modal'
    : 'modal edit-document-modal';

  const approveDocuments = useMemo(() => {
    if (showApproveScreen) return [document];
  }, [document, showApproveScreen]);

  return (
    isOpen &&
    !!document && (
      <DefaultModal
        className={className}
        key="edit-document-modal"
        wrap={true}
        padding={false}
        title={title || 'Edit Document'}
        headerContent={props.headerContent}
        onPin={
          allowPin
            ? () => {
                dispatch(
                  uiActions.addPinnedDocument({
                    type: 'document',
                    id: document.id,
                    patientId: document.patient_id,
                  }),
                );
                onClose();
              }
            : undefined
        }
        content={
          showApproveScreen ? (
            <BatchApproveDocuments
              documents={approveDocuments}
              patientId={document.patient_id}
              onClose={onClose}
            />
          ) : (
            <DocumentDetails
              key={document?.id}
              document={document}
              disableEdit={false}
              disablePatientBadge={false}
              onEdit={onClose}
              allowExpand={true}
              autoLoad={true}
              allowDelete={true}
              onClose={onClose}
              {...props}
            />
          )
        }
        isOpen={isOpen && !!document}
        onRequestClose={onClose}
      />
    )
  );
};

export default DocumentDetailsModal;
